import axios from 'axios';
import apiPath from './apiPath';

const api = {
  customerUpload(payload) {
    const data = new FormData();
    data.append('file', payload.file);
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${apiPath.IMEX_BO_CUSTOMER_BY_TEMPLATE.path
        }?from_web=true`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    });
  }
};

export default api;
